/* eslint-disable implicit-arrow-linebreak */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import { IBenefitAgePrice } from 'src/interfaces';
import BenefitsService from 'src/services/benefits.service';

export const usePatchBenefitAgeLines = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation((data: IBenefitAgePrice) => BenefitsService.patchBenefitAgePriceLine(data), {
    onSuccess: () => {
      AlertAdapter('Age lines add/edited successfully', 'success');
      queryClient.invalidateQueries({ queryKey: ['benefits/type'] });
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });
  return mutation;
};
